import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import canvas from './modules/canvas'
import countries from './modules/countries'
import local from './modules/local'
import modals from './modules/modals'
import requests from './modules/requests'

export default new Vuex.Store({
    modules: { local, canvas, countries, modals, requests },
    state: {
        params: {
            type: undefined,
            operation: undefined,
            bedrooms: undefined,
            bathrooms: undefined,
            stateId: undefined,
            countyId: undefined,
            cityId: undefined,
            // from: undefined
        },
        path: null as any
    },
    getters: {
        params: (state) => state.params,
        path: (state) => state.path
    },

    actions: {
        initApp({ dispatch, commit }, payload) {
            console.log(`initApp`, payload)
            dispatch('local/historiesSearchAction')
            dispatch('local/historiesViewAction')
            // dispatch('requests/propertiesFrom')
            dispatch('requests/operationsRequest', payload)
            dispatch('requests/typesRequest', payload)
            commit('countries/countryHandler', payload)
            commit('pathHandler', payload)
        }
    },
    mutations: {
        paramsHandler(state, payload) {
            state.params = payload
        },
        pathHandler: (state, payload) => {
            state.path = `/${payload}`
        }
    }
})
